













































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import SingleText from '@/components/common/elements/SingleText.vue';
import CreateDetailsPanel from '@/components/common/modules/CreateDetailsPanel.vue';
import { FieldChildrenProp } from '@/services/hexabase/types';

@Component({
  components: { SingleText, CreateDetailsPanel }
})
export default class InVoiceList extends Vue {
  // 親コンポーネントから送られてくる表示データ
  @Prop({ default: () => [] })
  private detailFieldsData!: Array<Array<FieldChildrenProp>>;
  // 親コンポーネントから送られてくるカラム情報
  @Prop({ default: '' })
  private detailFieldCols?: string;
  @Prop()
  parentRegistData: any;
  // 編集モード判定制御値
  @Prop({ default: true })
  private isEditMode?: boolean;
  // テーブルのデータ
  @Prop({ default: () => [] })
  private tableData!: Array<Array<FieldChildrenProp>>;

  // 登録用情報格納プロパティ
  private registData: any = {
    item: {},
    return_item_result: true, // true指定すると、登録されたアイテム情報を返します
    related_ds_items: {} // 関連するデータストアの新規・更新・削除を指定  詳細は以下を参照
  };
  private registFieldType: any = {};

  /**
   * 明細情報欄の追加ボタンを押されたイベントを親コンポーネントに通知する
   * @module inVoiceAddDetailArea
   * @return {void}
   */
  @Emit('inVoiceAddDetailArea')
  private inVoiceAddDetailArea(): void {
    // 通知のみのため、処理なし
  }

  /**
   * 明細情報の削除ボタンを押された配列値を受け取り
   * 親コンポーネントに登録データに削除用のデータを渡す
   * @module inVoiceDeleteRow
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('inVoiceDeleteRow')
  private inVoiceDeleteRow(index: number) {
    if (this.parentRegistData) {
      this.registData = { ...this.parentRegistData };
    }
    return { response: this.registData, index: index };
  }

  /**
   * 明細情報パネルで入力された値を受け取り、親コンポーネントに登録データを渡す
   * @module inVoiceCreateDetailsData
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('inVoiceCreateDetailsData')
  private inVoiceCreateDetailsData(response: any) {
    return response;
  }

  /**
   * 子コンポーネントから親コンポーネントに入力時の値を渡す
   * @module inVoiceCatchInputDetail
   * @param {any} response - 子コンポーネントより渡される値
   * @return {any} response - 親コンポーネントに渡す値
   */
  @Emit('inVoiceCatchInputDetail')
  private inVoiceCatchInputDetail(response: any) {
    return response;
  }
}
